import React, { useState } from 'react';

const XOGame = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [xIsNext, setXIsNext] = useState(true);
  const [gameOver, setGameOver] = useState(false);
  const [winningLine, setWinningLine] = useState(null);

  const calculateWinner = (squares) => {
    const lines = [
      [0, 1, 2], [3, 4, 5], [6, 7, 8], // Rows
      [0, 3, 6], [1, 4, 7], [2, 5, 8], // Columns
      [0, 4, 8], [2, 4, 6] // Diagonals
    ];

    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
        return { winner: squares[a], line: lines[i] };
      }
    }
    return null;
  };

  const handleClick = (index) => {
    if (board[index] || gameOver) return;

    const newBoard = board.slice();
    newBoard[index] = xIsNext ? 'X' : 'O';
    setBoard(newBoard);
    setXIsNext(!xIsNext);

    const result = calculateWinner(newBoard);
    if (result) {
      setGameOver(true);
      setWinningLine(result.line);
    } else if (newBoard.every(square => square !== null)) {
      setGameOver(true);
    }
  };

  const resetGame = () => {
    setBoard(Array(9).fill(null));
    setXIsNext(true);
    setGameOver(false);
    setWinningLine(null);
  };

  const getLineStyle = () => {
    if (!winningLine) return null;
    
    // Calculate line position based on winning combination
    const [start, end] = [winningLine[0], winningLine[2]];
    const isRow = Math.abs(start - end) === 2;
    const isColumn = Math.abs(start - end) === 6;
    const isDiagonal = Math.abs(start - end) === 8 || (start === 2 && end === 6);

    let style = {
      position: 'absolute',
      background: '#000',
      transform: 'translate(-50%, -50%)',
      pointerEvents: 'none',
    };

    if (isRow) {
      const row = Math.floor(start / 3);
      style = {
        ...style,
        width: '90%',
        height: '4px',
        left: '50%',
        top: `${(row * 33.33) + 16.67}%`,
      };
    } else if (isColumn) {
      const col = start % 3;
      style = {
        ...style,
        width: '4px',
        height: '90%',
        left: `${(col * 33.33) + 16.67}%`,
        top: '50%',
      };
    } else if (isDiagonal) {
      style = {
        ...style,
        width: '4px',
        height: '120%',
        left: '50%',
        top: '50%',
        transform: `translate(-50%, -50%) rotate(${start === 0 ? '45deg' : '-45deg'})`,
      };
    }

    return style;
  };

  const result = calculateWinner(board);
  const winner = result?.winner;
  const status = winner 
    ? `Winner: ${winner}`
    : board.every(square => square !== null)
    ? "Game Draw!"
    : `Next player: ${xIsNext ? 'X' : 'O'}`;

  return (
    <div className="w-full max-w-md mx-auto mt-8 bg-white rounded-lg shadow-md">
      <div className="p-6">
        <div className="text-2xl font-bold mb-4 text-center">{status}</div>
        <div className="grid grid-cols-3 gap-2 relative">
          {board.map((square, index) => (
            <button
              key={index}
              className={`w-24 h-24 text-4xl font-bold flex items-center justify-center rounded
                ${square === 'X' ? 'bg-blue-100 text-blue-600 hover:bg-blue-200' : 
                  square === 'O' ? 'bg-pink-100 text-pink-600 hover:bg-pink-200' :
                  'bg-gray-100 hover:bg-gray-200'}`}
              onClick={() => handleClick(index)}
            >
              {square}
            </button>
          ))}
          {winningLine && <div style={getLineStyle()} />}
        </div>
        <button
          className="mt-4 w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
          onClick={resetGame}
        >
          Reset Game
        </button>
      </div>
    </div>
  );
};

export default XOGame;